module.exports = __webpack_public_path__ + "static/01-1ec371ff37a538a37dc97ee84cdd06b0.jpg";